/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


export const styles:any[] = ['.img-footer[_ngcontent-%COMP%] {\n  height: 85px !important;\n  width: 225px !important;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  margin-left: 45%; }'];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiRDovUHJvamVjdHMvR2l0SHViL2VkdWNhdGlvbi1lZS13ZWIvc3JjL2FwcC9zaGFyZWQvZm9vdGVyL2Zvb3Rlci5jb21wb25lbnQuc2Nzcy5zaGltLm5nc3R5bGUudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9EOi9Qcm9qZWN0cy9HaXRIdWIvZWR1Y2F0aW9uLWVlLXdlYi9zcmMvYXBwL3NoYXJlZC9mb290ZXIvZm9vdGVyLmNvbXBvbmVudC5zY3NzIl0sInNvdXJjZXNDb250ZW50IjpbIiAiXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7OzsifQ==



// WEBPACK FOOTER //
// D:/Projects/GitHub/education-ee-web/src/$$_gendir/app/shared/footer/footer.component.scss.shim.ngstyle.ts